export const RLRVehicleInfoEnum = {
  NoVehicleCapture: 'NoVehicleCapture',
  HasVerifiedExistingPolicyVehicle: 'HasVerifiedExistingPolicyVehicle',
  AddNewPolicyVehicle: 'AddNewPolicyVehicle',
  OptionallyChangeExistingPolicyVehicle: 'OptionallyChangeExistingPolicyVehicle',
} as const;

export const RLRProductCodesEnum = {
  DRV_BATTERY: 'DRV_BATTERY',
  DRV_TYRE: 'DRV_TYRE',
  DRV_KEY: 'DRV_KEY',
  DRV_LEGAL: 'DRV_LEGAL',
  DRV_RECOVERY: 'DRV_RECOVERY',
  DRV_ATHOME: 'DRV_ATHOME',
  DRV_ONWARD: 'DRV_ONWARD',
  DRV_ONWARD_PREMIUM: 'DRV_ONWARD_PREMIUM',
  DRV_EUROPEAN: 'DRV_EUROPEAN',
} as const;

export type RLRVehicleInfoEnumType = keyof typeof RLRVehicleInfoEnum;
export type RLRProductCodesEnumType = keyof typeof RLRProductCodesEnum;

export type RLRProductType = {
  productCode: RLRProductCodesEnumType,
  title: string,
  subTitle: string,
  description: string,
  findOutMore: string,
  usuallyPerYear: number
}
